// extracted by mini-css-extract-plugin
export default {"scan-and-upload":"scanAndUpload_scan-and-upload__Ml-s0","upload-buttons":"scanAndUpload_upload-buttons__1VjBc"};